import { render, staticRenderFns } from "./IncentiveModal.vue?vue&type=template&id=bbad1958&"
import script from "./IncentiveModal.vue?vue&type=script&lang=js&"
export * from "./IncentiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports